import React, { useState } from 'react';
import { Tabs, Breadcrumb } from 'antd'
import decode from 'jwt-decode';
import { HomeOutlined } from '@ant-design/icons';
import ReportView from './ReportView';
import ReportDownload from './ReportDownload';
import HostReport from './HostReport/HostReport';
import { useSelector } from 'react-redux';
import AdminDashboardLayout from '../Common/AdminDashboardLayout/AdminDashboardLayout';
import { USER_HOST } from '../Common/constants';
import './ReportContainer.scss';

const { TabPane } = Tabs;
const ReportContainer = () => {

    const [activeTabKey, setActiveTabKey] = useState("0");
    const [activeSubReportKey, setActiveSubReportKey] = useState("booking-tracker");
    const reportsStatus = useSelector(state => state?.report?.reportStatus.data)
    
    // Check user role
    const authDetails = useSelector((state) => state?.auth?.loginDetails?.data?.token || null);
    const userType = authDetails ? decode(authDetails)?.authorities?.[0] : null;

    const handleTabsChange = tab => {
        setActiveTabKey(tab);
        if (tab === "0") {
            setActiveSubReportKey("booking-tracker");
        }
    }

    const getSubReportName = () => {
        const reportNames = {
            'booking-tracker': 'Booking Tracker',
            'revenue-tracker': 'Revenue Tracker',
            'payment-tracker': 'Payment Tracker',
            'space-tracker': 'Space Tracker',
            'user-Tracker': 'User Tracker',
            'summary-Tracker': 'Summary Tracker'
        };
        return reportNames[activeSubReportKey] || 'Reports';
    }

    // const isDownloading = () => {
    //     return Boolean(reportsStatus.filter(report => report.taskStatus === 'PENDING').length);
    // };

    return (
        <AdminDashboardLayout>
            <div className="report-container-wrapper">
                <div className="report-breadcrumb">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>Reports</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{activeTabKey === "0" ? "Reports View" : "Reports Download"}</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{activeTabKey === "0" ? getSubReportName() : "Download Reports"}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="report-tabs-container">
                    <Tabs
                        type="card"
                        className="report-tab reporting-outer-wrap"
                        onChange={handleTabsChange}
                        activeKey={activeTabKey}
                        key={activeTabKey}
                    >
                        <TabPane tab="Reports View" key="0" forceRender={false}>
                            <ReportView onSubReportChange={setActiveSubReportKey} />
                        </TabPane>
                        <TabPane tab={`Reports Download`} key="1">
                            <ReportDownload />
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </AdminDashboardLayout>
    )
};

export default ReportContainer;